import React from 'react'

import { Button } from 'system'

const refreshData = () => fetch('/__refresh', { method: 'post' })

export const DevRefreshButton = props => (
  <Button
    onClick={refreshData}
    bg="#000"
    color="#fff"
    opacity={0.1}
    outline={0}
    position="fixed"
    px="16px"
    py="8px"
    right={0}
    top={0}
    zIndex={9999}
    fontFamily="system-ui"
    fontSize="0.6rem"
    fontWeight="bold"
    textStyle="trackedCaps"
    transitionProperty="opacity"
    css={{
      '&:hover': {
        opacity: 1,
      },
    }}
    {...props}
  >
    Refresh Data
  </Button>
)
